export interface Movies {
  fileName: string;
  copyrightInfo: string;
  url: string;
}

export interface FileUpload {
  id: string;
  mimeType: string;
  blob: Blob;
}

export interface Screenshot {
  identifier: string;
  url: string;
  imageBlobName: string;
  score: number;
  hint: string;
}

export interface ScreenshotData {
  groupLanguageKey: string;
  descriptionLanguageKey: string;
  nameLanguageKey: string;
  sortId: number;
  id: string;
  fileName: string;
  fileGeneratedName: string;
}

export interface UploadData {
  nameLanguageKey: string;
  id: string;
  fileName: string;
  fileGeneratedName: string;
}

export interface ResponseData {
  [key: string]: string;
}

export interface MediaRecorderDataEvent {
  data: Blob;
}
